export interface Testimonial {
  id: string;
  name: string;
  role: string;
  location: string;
  avatar: string;
  rating: number;
  quote: string;
  expertise: string;
  earnings?: string;
  projectsCompleted?: number;
}

export const testimonials: Testimonial[] = [
  {
    id: "1",
    name: "Dr. Sarah Chen",
    role: "AI Trainer",
    location: "San Francisco, USA",
    avatar: "SC",
    rating: 5,
    quote:
      "Working with Unimerg has been transformative for my career. The flexibility to work on cutting-edge AI projects while maintaining my research position is invaluable. The compensation is competitive, and the team is incredibly supportive.",
    expertise: "Machine Learning",
    earnings: "$12,000+",
    projectsCompleted: 47,
  },
  {
    id: "2",
    name: "Marcus Johnson",
    role: "Data Annotator",
    location: "London, UK",
    avatar: "MJ",
    rating: 5,
    quote:
      "I started as a part-time contributor and now I'm earning a full-time income. The platform is intuitive, payments are always on time, and I love being part of something that's shaping the future of technology.",
    expertise: "Computer Vision",
    earnings: "$8,500+",
    projectsCompleted: 124,
  },
  {
    id: "3",
    name: "Priya Patel",
    role: "Linguistic Specialist",
    location: "Mumbai, India",
    avatar: "PP",
    rating: 5,
    quote:
      "As a multilingual specialist, I've found the perfect platform to utilize my skills. The variety of projects keeps things interesting, and I appreciate how Unimerg values quality over quantity.",
    expertise: "NLP & Translation",
    earnings: "$15,000+",
    projectsCompleted: 89,
  },
  {
    id: "4",
    name: "James Rodriguez",
    role: "Subject Matter Expert",
    location: "Toronto, Canada",
    avatar: "JR",
    rating: 5,
    quote:
      "The expert review projects allow me to contribute my legal expertise to AI development. It's rewarding to know my work helps create more accurate and ethical AI systems.",
    expertise: "Legal & Compliance",
    earnings: "$20,000+",
    projectsCompleted: 35,
  },
  {
    id: "5",
    name: "Elena Kowalski",
    role: "Content Moderator",
    location: "Berlin, Germany",
    avatar: "EK",
    rating: 5,
    quote:
      "The flexible hours are perfect for my lifestyle. I can work when it suits me while contributing to important safety initiatives. The community here is also very welcoming.",
    expertise: "Content Safety",
    earnings: "$6,800+",
    projectsCompleted: 156,
  },
];
